import { render, staticRenderFns } from "./ViewPDFModal.vue?vue&type=template&id=52ff93fd&scoped=true&"
import script from "./ViewPDFModal.vue?vue&type=script&lang=js&"
export * from "./ViewPDFModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewPDFModal.vue?vue&type=style&index=0&id=52ff93fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ff93fd",
  null
  
)

export default component.exports